import { graphql } from '@/gql'

export const CompanyRecruiterDetailQuery = graphql(/* GraphQL */ `
  query CompanyRecruiterDetailQuery($companyRecruiterId: ID!) {
    companyRecruiter(id: $companyRecruiterId) {
      ...CompanyRecruiterDetailFragment
    }
  }
`)

export const RecruiterActivityHiresQuery = graphql(/* GraphQL */ `
  query RecruiterActivityHiresQuery($accounts: [ID!], $recruiters: [ID!]) {
    hires(accounts: $accounts, recruiters: $recruiters, first: 50) {
      data {
        id
        status
        startDate
        endDate
        currency
        recruiterFee
        worker {
          id
          name
          avatar
          avatarPath @client
          initials
        }
        job {
          id
          name
        }
        company {
          id
          name
        }
      }
      paginatorInfo {
        total
      }
    }
  }
`)

export const RecruiterConversationsQuery = graphql(/* GraphQL */ `
  query RecruiterConversationsQuery($companyId: ID!, $recruiterId: ID!) {
    conversations(accounts: [$companyId, $recruiterId]) {
      data {
        ...ConversationsViewFragment
      }
    }
  }
`)

export const RecruiterCompliancesQuery = graphql(/* GraphQL */ `
  query RecruiterCompliancesQuery($recruiterId: ID!, $names: [ComplianceName!]) {
    compliance(id: $recruiterId, names: $names) {
      ...ComplianceRowFragment
    }
  }
`)

export const CompanyRecruiterNotesQuery = graphql(/* GraphQL */ `
  query CompanyRecruiterNotesQuery($companyRecruiterId: ID!) {
    companyRecruiter(id: $companyRecruiterId) {
      ...CompanyRecruiterNotesFragment
    }
  }
`)
